import React, { useState } from 'react'
import { Search, Settings, Coffee, Menu, X } from 'lucide-react'

interface HeaderProps {
  onSearchChange?: (query: string) => void
  onSettingsClick?: () => void
  onSidebarToggle?: () => void
  isSidebarOpen?: boolean
}

const Header: React.FC<HeaderProps> = ({ 
  onSearchChange, 
  onSettingsClick, 
  onSidebarToggle,
  isSidebarOpen = true 
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [showSettings, setShowSettings] = useState(false)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    setSearchQuery(query)
    onSearchChange?.(query)
  }

  const handleSettingsClick = () => {
    if (onSettingsClick) {
      onSettingsClick()
    } else {
      setShowSettings((prev) => !prev)
    }
  }

  return (
    <header className="header">
      {/* Logo and Sidebar Toggle */}
      <div className="flex items-center space-x-3">
        <button
          className="lg:hidden p-2 text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100 rounded-lg transition-colors"
          aria-label="Toggle sidebar"
          onClick={onSidebarToggle}
        >
          {isSidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
        <Coffee className="w-8 h-8 text-coffee-600" />
        <h1 className="text-xl font-semibold text-neutral-900">
          Coffee Visualizer
        </h1>
      </div>
      
      {/* Search Bar */}
      <div className="flex-1 max-w-md mx-8">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-neutral-400" />
          <input
            type="text"
            placeholder="Search coffee shops..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full pl-10 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-coffee-500 focus:border-transparent"
          />
        </div>
      </div>
      
      {/* Controls */}
      <div className="flex items-center space-x-4">
        <button
          className="p-2 text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100 rounded-lg transition-colors"
          aria-label="Open settings"
          onClick={handleSettingsClick}
        >
          <Settings className="w-5 h-5" />
        </button>
      </div>
      {/* Settings Modal (placeholder) */}
      {showSettings && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
          tabIndex={-1}
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white rounded-lg shadow-lg p-6 min-w-[300px]">
            <h2 className="text-lg font-semibold mb-4">Settings</h2>
            <p className="mb-4">Settings menu coming soon...</p>
            <button
              className="px-4 py-2 bg-coffee-500 text-white rounded hover:bg-coffee-600"
              onClick={() => setShowSettings(false)}
              autoFocus
            >
              Close
            </button>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header 